import { Checkbox, Grid } from '@mui/material'

import Dialog from './Dialog'
import GridCircularProgress from './GridCircularProgress'
import { useGetBackendFeaturesQuery } from '../hooks/api-slice'
import { config } from '../settings/configs'
import { titlesImpostazioni } from '../settings/settings'
import { baseFeatures, extraFeatures } from '../settings/features'

const frontendFeatures = config?.features
const baseFeaturesNames = [...Object.keys(baseFeatures), 'classificheAvulse']
const extraFeaturesNames = [...Object.keys(extraFeatures), 'excel', 'mail']

const DialogFeatures = ({ open, handleClose }) => {
  const { data: backendFeatures } = useGetBackendFeaturesQuery()

  const FeaturesList = ({ title, features }) => {
    return (
      <Grid size={{ xs: 12, md: 6 }}>
        <h3>{title}</h3>
        {features.sort().map(f => {
          const fInFrontend = Object.keys(frontendFeatures)?.includes(f)
          const fInBackend = Object.keys(backendFeatures)?.includes(f)
          const fInBoth = fInFrontend && fInBackend

          const fFrontend = !!frontendFeatures?.[f]
          const fBackend = !!backendFeatures?.[f]
          const fIndeterminate = fInBoth && fFrontend !== fBackend

          const fName =
            f.charAt(0).toUpperCase() +
            f
              .slice(1)
              .replace(/([a-z])([A-Z])/g, '$1 $2')
              .toLowerCase()

          return (
            <Grid
              key={f}
              container
              alignItems='center'
              justifyContent='space-between'
              sx={{ width: '100%' }}
            >
              {fName}
              <Checkbox
                name={f}
                checked={
                  (fInBoth && fFrontend && fBackend) ||
                  (fInBackend && fBackend) ||
                  (fInFrontend && fFrontend)
                }
                indeterminate={fIndeterminate}
                color={fIndeterminate ? 'default' : 'primary'}
                readOnly
              />
            </Grid>
          )
        })}
      </Grid>
    )
  }

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      title={titlesImpostazioni.titleFeatures}
    >
      {!frontendFeatures || !backendFeatures ? (
        <GridCircularProgress />
      ) : (
        <Grid
          container
          columnSpacing={10}
          rowSpacing={5}
          sx={{ width: '100%' }}
        >
          <FeaturesList title='Base' features={baseFeaturesNames} />
          <FeaturesList title='Extra' features={extraFeaturesNames} />
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogFeatures
